import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { XCircle } from 'react-bootstrap-icons'
import axiosService from '../../../../../../utils/AxiosService'
import { toastSuccess, toastError } from '../../../../../FormComponents/Toasts'

// Lets the PM see and revoke links they've already generated - per the
// workflow spec, a link "must remain valid until manually revoked by the
// PM", but until now there was no way to actually do that once one had
// been copied. Loaded fresh every time the modal opens rather than kept in
// sync with the copy-link actions below, since a link could have been
// generated in an earlier session entirely.
export default function ActiveLinksSection({ refreshKey }) {
  const { id } = useParams()
  const [grants, setGrants] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    axiosService.get(`/api/project_manager/campaigns/${id}/draft_access_grants`)
      .then(setGrants)
      .catch(({ data: { error } }) => toastError(error))
      .finally(() => setLoading(false))
  }, [id, refreshKey])

  const revoke = (grant) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/draft_access_grants/${grant.id}/revoke`)
      .then(() => {
        setGrants(grants.filter(g => g.id !== grant.id))
        toastSuccess('Link revoked')
      })
      .catch(({ data: { error } }) => toastError(error))
  }

  if (loading || grants.length === 0) return null

  return (
    <div className="mb-4">
      <p className="font-bold mb-2 dark:text-white">Active Links</p>
      <div className="flex flex-col gap-2 max-h-40 overflow-y-auto">
        {grants.map(grant => (
          <div
            key={grant.id}
            className="flex items-center justify-between px-3 py-2 rounded-lg border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter"
          >
            <span className="text-sm dark:text-white">
              {grant.recipient_role === 'client' ? 'Client' : grant.influencer_name} · {grant.action_ids.length} action{grant.action_ids.length === 1 ? '' : 's'}
            </span>
            <button
              onClick={() => revoke(grant)}
              className="flex items-center gap-1 text-sm font-medium text-red-500"
              title="Revoke this link"
            >
              <XCircle /> Revoke
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
